import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import VerifySubscriberForm from "../components/VerifySubscriberForm";
import useSubscribers from "../../common/hooks/pages/useSubscribers";
import { usePopup } from "../../common/contexts/PopupContext";
import { useMutation } from "react-query";
import { setLocalStorage } from "../../common/helpers/browserStorage";
import { useAuth } from "../../common/contexts/AuthContext";

function VerifySubscriberContainer() {
  const { token } = useParams();

  const { setAccessToken } = useAuth();
  const { toast } = usePopup();

  const { verifySubscriber } = useSubscribers();

  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation({
    mutationFn: verifySubscriber,
    onSuccess: (res) => {
      const { message, accessToken } = res?.data || {};

      setLocalStorage("accessToken", accessToken);
      setAccessToken(accessToken);
      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while verifying!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    // Call the mutation when the component mounts
    mutate({ token });
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <VerifySubscriberForm
      onSubmit={(data) => {
        mutate({ token });
      }}
      isSubmitting={isLoading}
    />
  );
}

export default VerifySubscriberContainer;
